import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { AnyRouteKey } from '../../../app.routes-config';
import { LocalizedLinkPipe } from '../../../pipes/localized-link.pipe';

interface FooterLink {
  labelKey: string;
  routeKey: AnyRouteKey;
}

@Component({
  imports: [RouterLink, TranslatePipe, LocalizedLinkPipe],
  selector: 'app-footer',
  styleUrls: ['./footer.scss'],
  templateUrl: './footer.html',
})
export class Footer {
  protected readonly currentYear = new Date().getFullYear();

  protected readonly links: FooterLink[] = [
    { labelKey: 'nav.about', routeKey: 'about' },
    { labelKey: 'nav.usefulLinks', routeKey: 'usefulLinks' },
    { labelKey: 'nav.directory', routeKey: 'directory' },
    { labelKey: 'megaMenu.suggestGym', routeKey: 'suggestGym' },
  ];
}
